<template lang="html">
<div></div>
</template>

<script>
export default {
  mounted () {
    var query = this.$route.query
    if (query.token) {
      this.switchUrl(query.token)
    } else {
      this.$router.push({ path: '/app/login' })
    }
  },
  methods: {
    switchUrl (token) {
      this.$api.getDownloadFilesInfo(token, response => {
        var json = response
        var email = json.data.user_info.email
        if (json.err === 0) {
          var uid = localStorage.getItem('uid')
          if (json.data.pkg_download.user_info.id !== uid) {
            localStorage.removeItem('token')
          }
          this.$router.push({ path: '/app/login?email=' + email + '&download=' + token })
        } else {
          if (json.data.errno === 226) {
            localStorage.removeItem('token')
            if (json.data.user_info.is_complete === 1) {
              if (this._global.config.system === 'ios') {
                this.$router.push({ path: '/app/phone?token=' + token + '&type=download' })
              } else if (this._global.config.system === 'android') {
                this.$router.push({ path: '/app/phone?token=' + token + '&type=download' })
              } else {
                this.$router.push({ path: '/app/login?email=' + email + '&download=' + token })
              }
            } else {
              this.$router.push({ path: '/app/complete?token=' + token + '&email=' + email })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>
